import $ from 'jquery';
import 'jquery.marquee';

$(function() {
    $(document).trigger('sticky_kit:recalc');

    // Accessibility
    function changeState(e) {
        const { keyCode } = e;
        if (!keyCode || keyCode === 9 || keyCode === 37
            || keyCode === 38 || keyCode === 39 || keyCode === 40) {
            if (document.documentElement.getAttribute('data-state') !== e.type) {
                document.documentElement.setAttribute('data-state', e.type);
            }
        }
    }
    window.addEventListener('keydown', changeState);
    window.addEventListener('mousemove', changeState);

    // Home
    $('.marquee').marquee({
        duration: 50000,
        duplicated: true,
        gap: 0,
        direction: 'left',
        pauseOnHover: true,
        startVisible: true,
    });

    // Sticky sidebar
    if ($('.is-sticky').parent().innerHeight() > $('.is-sticky').innerHeight()) {
        $('.is-sticky').stick_in_parent({
            inner_scrolling: false,
        });
    }
});
